// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_DC_REQUEST_DK = 'FETCH_ACCESSORIES_DC_REQUEST_DK';
export const FETCH_ACCESSORIES_DC_SUCCESS_DK = 'FETCH_ACCESSORIES_DC_SUCCESS_DK';
export const FETCH_ACCESSORIES_DC_FAILURE_DK = 'FETCH_ACCESSORIES_DC_FAILURE_DK';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_ACCESSORIES_DC_REQUEST_DK = 'CREATE_ACCESSORIES_DC_REQUEST_DK';
export const CREATE_ACCESSORIES_DC_SUCCESS_DK = 'CREATE_ACCESSORIES_DC_SUCCESS_DK';
export const CREATE_ACCESSORIES_DC_FAILURE_DK = 'CREATE_ACCESSORIES_DC_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_ACCESSORIES_DC_DK = 'CREATE_USER_FORM_ACCESSORIES_DC_DK';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_ACCESSORIES_DC_REQUEST_DK = 'UPDATE_ACCESSORIES_DC_REQUEST_DK';
export const UPDATE_ACCESSORIES_DC_SUCCESS_DK = 'UPDATE_ACCESSORIES_DC_SUCCESS_DK';
export const UPDATE_ACCESSORIES_DC_FAILURE_DK = 'UPDATE_ACCESSORIES_DC_FAILURE_DK';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_ACCESSORIES_DC_REQUEST_DK = 'FETCH_SINGLE_ACCESSORIES_DC_REQUEST_DK';
export const FETCH_SINGLE_ACCESSORIES_DC_SUCCESS_DK = 'FETCH_SINGLE_ACCESSORIES_DC_SUCCESS_DK';
export const FETCH_SINGLE_ACCESSORIES_DC_FAILURE_DK = 'FETCH_SINGLE_ACCESSORIES_DC_FAILURE_DK';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_ACCESSORIES_DC_REQUEST_DK = 'DELETE_ACCESSORIES_DC_REQUEST_DK';
export const DELETE_ACCESSORIES_DC_SUCCESS_DK = 'DELETE_ACCESSORIES_DC_SUCCESS_DK';
export const DELETE_ACCESSORIES_DC_FAILURE_DK = 'DELETE_ACCESSORIES_DC_FAILURE_DK';

// USERFORM RESET

export const ACCESSORIES_DC_USERFORM_RESET_DK = 'ACCESSORIES_DC_USERFORM_RESET_DK';

// navigate to unit component
export const NAVIGATE_ACCESSORIES_DC_DETAILS_DK = 'NAVIGATE_ACCESSORIES_DC_DETAILS_DK';
// navigate to company component
export const NAVIGATE_ACCESSORIES_DC_DK = 'NAVIGATE_ACCESSORIES_DC_DK';
export const ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK = 'ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK';
export const ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK = 'ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK';


// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_DC_STYLE_REQUEST_DK = 'FETCH_ACCESSORIES_DC_STYLE_REQUEST_DK';
export const FETCH_ACCESSORIES_DC_STYLE_SUCCESS_DK = 'FETCH_ACCESSORIES_DC_STYLE_SUCCESS_DK';
export const FETCH_ACCESSORIES_DC_STYLE_FAILURE_DK = 'FETCH_ACCESSORIES_DC_STYLE_FAILURE_DK';




// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_DC_INVOICE_REQUEST = 'FETCH_ACCESSORIES_DC_INVOICE_REQUEST';
export const FETCH_ACCESSORIES_DC_INVOICE_SUCCESS = 'FETCH_ACCESSORIES_DC_INVOICE_SUCCESS';
export const FETCH_ACCESSORIES_DC_INVOICE_FAILURE = 'FETCH_ACCESSORIES_DC_INVOICE_FAILURE';

export const RESET_ACCESSORIES_DC_INVOICE = 'RESET_ACCESSORIES_DC_INVOICE';
